import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index1'

import registerShop from '@/pages/registerShop'
import joinShop from '@/pages/joinShop'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/registerShop',
    name: 'registerShop',
    component: registerShop
  }, {
    path: '/joinShop',
    name: 'joinShop',
    component: joinShop
  }],
})



// WEBPACK FOOTER //
// ./src/router/index.js